/* eslint-disable no-nested-ternary */
import { Avatar, Box, Divider, Grid, Rating, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { Review } from '../../apiTypes';
import EditModal from '../../components/EditModal';
import FormSwitch from '../../components/forms/FormSwitch';
import { t } from '../../constants/translations';
import { useAdmin } from '../../contexts/admin.context';
import { useLocale } from '../../contexts/locale.context';
import { updateDoc } from '../../utils/api';

type Props = {
  review: DbDocument<Review>;
  onChange?: () => void;
  onClose: () => void;
};

const ReviewModal = ({ review, onClose, onChange }: Props) => {
  const { cafeSlug } = useAdmin();
  const { lang } = useLocale();

  const form = useForm<Review>({ defaultValues: review });

  const saveChanges = async (values: Review) => {
    await updateDoc<Review>(`cafes/${cafeSlug}/reviews/${review.id}`, {
      isPublic: values.isPublic || false,
      isNew: false,
    });
    if (onChange) {
      onChange();
    }
    onClose();
  };

  return (
    <EditModal<Review> title="" open onClose={onClose} submitButton={t.done[lang]} onSubmit={saveChanges} form={form}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Avatar src={review.photoURL} />

            <div>
              <Typography sx={{ fontWeight: 600 }}>{review.name}</Typography>
              {review.phone && <Typography>{review.phone}</Typography>}
              {review.email && <Typography>{review.email}</Typography>}
            </div>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={12} sm={4} textAlign="center">
          <Typography variant="overline" component="h6">
            {t.dishes[lang]}
          </Typography>
          <Rating readOnly value={review.dishes} />
        </Grid>

        <Grid item xs={12} sm={4} textAlign="center">
          <Typography variant="overline" component="h6">
            {t.service[lang]}
          </Typography>
          <Rating readOnly value={review.service} />
        </Grid>

        <Grid item xs={12} sm={4} textAlign="center">
          <Typography variant="overline" component="h6">
            {t.atmosphere[lang]}
          </Typography>
          <Rating readOnly value={review.atmosphere} />
        </Grid>

        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="overline" component="h6">
            {t.comment[lang]}
          </Typography>
          <Typography>{review.comment}</Typography>
        </Grid>

        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <FormSwitch name="isPublic" label={t.show_for_visitors[lang]} />
        </Grid>
      </Grid>
    </EditModal>
  );
};

export default ReviewModal;
